import { setTag, setUser } from '@sentry/react';
/**
 * В jwt id приходит с префиксом типа ("compass_user:123", "guest:<uuid>"),
 * а во всех остальных проектах в sentry ищем просто по user.id:123 — убираем префикс.
 *
 * @param {IJwtUser} user - Пользователь из jwt.
 * @returns {string|undefined}
 */
export const getSentryUserId = (user) => {
    const { id, type } = user ?? {};
    if (!id) {
        return undefined;
    }
    return type && id.startsWith(`${type}:`) ? id.slice(type.length + 1) : id;
};
/**
 * Проставляет пользователя в scope, чтобы он был во всех следующих событиях.
 *
 * @param {IJwtUser} user - Пользователь из jwt.
 * @returns {void}
 */
export const setSentryUser = (user) => {
    const id = getSentryUserId(user);
    if (!id) {
        return;
    }
    setUser({ id });
    setTag('user.type', user?.type ?? 'unknown');
};
